module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-inner specal"
  }, [_c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%",
      "color": "#8e8e93"
    }
  }, [_vm._v(_vm._s(this.attribute.label))]), _vm._v(" "), _c('div', {
    staticClass: "item-after guding",
    staticStyle: {
      "border": "1px solid #e7e7e7"
    }
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    staticClass: "pb-standalone",
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "center",
      "color": "rgb(8, 148, 236)"
    },
    attrs: {
      "type": "text",
      "value": "查看载体图谱",
      "readonly": "readonly"
    },
    on: {
      "click": _vm.gototlno
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae058e54","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/finder/FinderBox/FinderAttrTVBox.vue
// module id = 1708
// module chunks = 8